<template>
  <v-container fluid>
    <v-row justify="end">
      <v-menu bottom left :close-on-content-click="false" v-model="menu">
        <template v-slot:activator="{ on }">
          <v-btn small fab icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-cogs</v-icon> </v-list-item-action
              >Section Settings
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-select
                label="Show/Hide"
                multiple
                item-text="name"
                item-value="id"
                :outlined="outlinedInputs"
                :items="list"
                v-model="visibleComponents"
                @change="onChange"
              ></v-select>
            </v-list-item>

            <v-list-item>
              <v-select
                label="No of Columns"
                :outlined="outlinedInputs"
                :items="availableColumns"
                v-model="cols"
                @change="onChange"
              ></v-select>
            </v-list-item>
          </v-list>

          <v-card-actions class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false" color="warning">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-row>
    <v-row align="stretch">
      <v-col
        cols="12"
        :sm="noOfColumns"
        v-for="c in visibleComponentsList"
        :key="c.id"
      >
        <component
          :key="c.id"
          :is="c.component"
          v-bind="c.props"
          :data="data"
          :columns="cols"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <code>visible: {{ list }}</code>
      <code>columns: {{ cols }}</code>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "basic-components-list",
  props: {
    list: {
      type: Array,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => null,
    },
    columns: {
      type: Number,
      default: () => 3,
    },
    visibleItems: {
      type: Array,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      menu: false,
      cols: this.columns,
      visibleComponents: this.list
        ? this.visibleItems
          ? this.list
              .filter((item) => this.visibleItems.indexOf(item.name) != -1)
              .map((item) => item.id)
          : this.list.filter((item) => item.visible).map((item) => item.id)
        : [],
      availableColumns: [2, 3, 4, 6],
    };
  },

  computed: {
    visibleComponentsList() {
      return this.list
        ? this.list.filter(
            (item) => this.visibleComponents.indexOf(item.id) != -1
          )
        : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    noOfColumns() {
      return 12 / this.cols;
    },
  },

  methods: {
    onChange() {
      this.$emit("change", {
        columns: this.cols,
        visibleItems: this.list
          .filter((item) => this.visibleComponents.indexOf(item.id) != -1)
          .map((item) => item.name),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BasicComponentsList.vue